module.exports = __webpack_public_path__ + "static/media/B_food_1_length.6f8f7a34.png";